import { websocketBaseUrl } from './environment';

export const url = `${websocketBaseUrl}`;

export { websocketBaseUrl };
